import React, { useState, useEffect } from "react";
import { Checkbox, Button, Select } from "antd";
import { find } from "lodash";
import css from "./FieldSelector.module.css";

export const FieldSelector = ({ columns, defaultSelectedColumns, onApply, onSaveSelected, savedFilters }) => {
  const [selectedColumns, setSelectedColumns] = useState(
    defaultSelectedColumns ? defaultSelectedColumns :
    columns.reduce((acc, col) => ({ ...acc, [col.dataIndex]: true }), {})
  );
  
  const fieldsSavedFilters = savedFilters.filter(f=>f.type == 'fields');

  const [isVisible, setIsVisible] = useState(false);
  const [selectedFilter, setSelectedFilter] = React.useState(null);
  const allSelected = Object.values(selectedColumns).every(Boolean);
  
  useEffect(() => {
    const defaultSavedFilter = find(fieldsSavedFilters, f=>f['default']);
    if(!selectedFilter && defaultSavedFilter) {
      setSelectedFilter(defaultSavedFilter.id)
    }
  }, [fieldsSavedFilters]);

  const handleCheckboxChange = (dataIndex) => {
    setSelectedColumns((prev) => ({
      ...prev,
      [dataIndex]: !prev[dataIndex],
    }));
  };

  const handleSelectAll = () => {
    const allSelected = Object.values(selectedColumns).every(Boolean);
    const newSelection = columns.reduce(
      (acc, col) => ({ ...acc, [col.dataIndex]: !allSelected }),
      {}
    );
    setSelectedColumns(newSelection);
  };
  
  const applySaved = (id) => {
    setSelectedFilter(id);
    const filter = find(fieldsSavedFilters, f=>f.id == id);
    if(filter) {
      setSelectedColumns(filter.payload);  
    }
  }

  return (
    <div className={css.selectorHolder}>
      <Button onClick={() => setIsVisible(!isVisible)}>
        {isVisible ? "Hide Field Selector" : "Show Field Selector"}
      </Button>

      {isVisible && (
        <div className={css.selectorDropdown}>
          <div className={css.selectorHeader}>
            <Button onClick={handleSelectAll}>
              {allSelected ? "Unselect All" : "Select All"}
            </Button>
            <Button
              type="primary"
              onClick={() => onApply(selectedColumns)}
              style={{ marginLeft: "10px" }}
            >
              Apply
            </Button>
          </div>
          <div className={css.columnsContainer}>
            {columns.map((col) => (
              <div key={col.dataIndex} className={css.columnsItem}>
                <Checkbox
                  checked={selectedColumns[col.dataIndex]}
                  onChange={() => handleCheckboxChange(col.dataIndex)}
                >
                  {col.title}
                </Checkbox>
              </div>
            ))}
          </div>
          <div className={css.selectorFooter}>
            <Select
              options={fieldsSavedFilters}
              id="saved"
              className={css.savedFilters}
              onChange={applySaved}
              value={selectedFilter}
              placeholder="Saved Filters"
            />

            
            <Button onClick={()=>onSaveSelected(selectedColumns)}>
              Save Fields
            </Button>

          </div>
        </div>
      )}
    </div>
  );
};
